import { useEffect, useContext } from 'react';
import FormGroup from '../../FormGroup';
import SectionHeader from '../../SectionHeader';
import usePostData from '../../../hooks/usePostData';
import GlobalContext from '../../../contexts';
import translating from '../translate.json';
import fields from '../fields';
import { useNavigate } from 'react-router-dom';

import '../styles.scss';

const CreateReportField = () => {
  const navigate = useNavigate();
  const { postData, res } = usePostData();
  const { categoriesList, setLink } = useContext(GlobalContext);

  useEffect(() => {
    if (res?.id) {
      setLink(null);
      navigate(`/labs/report?added=true`);
    }
  }, [res]);

  const onSubmit = (data) => {
    console.log(data);
    postData('report-text', data);
  };
  return (
    <div className="create-text">
      <SectionHeader title={translating.createReportField}></SectionHeader>
      <FormGroup
        fields={fields()}
        onSubmit={onSubmit}
        categories={categoriesList}
      ></FormGroup>
    </div>
  );
};

export default CreateReportField;
